// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"622a8c21","633":"b84df57f"}[chunkId] + ".chunk.js";
};